
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faquh347FP_QNpTE1pkWkVtNOp__45KFNLVJSIFL2bQYhYDkMeta } from "/codebuild/output/src850997479/src/src/pages/faq.vue?macro=true";
import { default as menuTU3tO0CZ9IfPO_45rR_tIhIDFSGiMi5X6emgecZdOWxcEMeta } from "/codebuild/output/src850997479/src/src/pages/menu.vue?macro=true";
import { default as indexjjC_p_45pk3ifKly9rqwYsnSfM1Uj_HsPc5nkydmmk09cMeta } from "/codebuild/output/src850997479/src/src/pages/index.vue?macro=true";
import { default as contact5zbRqb_Dbu2Mpz98UuEfJQpllvHUU40NGU73e8S568kMeta } from "/codebuild/output/src850997479/src/src/pages/contact.vue?macro=true";
import { default as tutorialtY1Pft_45rUmL2sz_sQcBkh3kywfV2XhDamfpKxU9WFMkMeta } from "/codebuild/output/src850997479/src/src/pages/tutorial.vue?macro=true";
import { default as agreementcRWWH8GoChtO8UEBZ_45pL4wlLrZQd0bA7iqnxR6zaAI0Meta } from "/codebuild/output/src850997479/src/src/pages/agreement.vue?macro=true";
import { default as about_45passVl4TIF9O1oQKWJtvXPUqNQC3hAYkFDKx7Nnk6t4i4IUMeta } from "/codebuild/output/src850997479/src/src/pages/about-pass.vue?macro=true";
import { default as indexKyjhLm3NdOTbwWAeamUnYLYM7LYGRG3aIVCXprARDZoMeta } from "/codebuild/output/src850997479/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93lfyk_45b3Zya5vh8JXM_fTLqYFkmFl5enTIBeG6aQ5LyYMeta } from "/codebuild/output/src850997479/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancezUA65xs3wUzDqcDqLD2l2AF7rw26Gidk3dVUDMi03f0Meta } from "/codebuild/output/src850997479/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93QwPLg4DRe9R0HDgaRjgpX6DigraGu8zx5L2Y4TFFdXIMeta } from "/codebuild/output/src850997479/src/src/pages/notice/[id].vue?macro=true";
import { default as indexMuvRDR8YwTDG3ZMLPYSgAbdWnS4_45gXFXoo5sXupDkpIMeta } from "/codebuild/output/src850997479/src/src/pages/coupon/index.vue?macro=true";
import { default as index0WfxuuDPjRzmdzlB8xhTOyCOMgCHSSETfJKaroKlQVcMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/index.vue?macro=true";
import { default as indexaFDEdKW3leXHzuXIIpfz0tOCsOWvRdLywCc6TqAwNw0Meta } from "/codebuild/output/src850997479/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93icDSfexyjTsZ2_45TXaL6Sj7uz_Cm9Xl2KQv8T8NikHUQMeta } from "/codebuild/output/src850997479/src/src/pages/parking/[id].vue?macro=true";
import { default as indexHWsD6gdQp5sIfLOdoJkvOC65SciGXtpe6_45sntKtY5KkMeta } from "/codebuild/output/src850997479/src/src/pages/history/index.vue?macro=true";
import { default as indexSpX5nBc0MeKXmNU9bd7lJQTHknmkOEe4cpveDqy4ePMMeta } from "/codebuild/output/src850997479/src/src/pages/monthly/index.vue?macro=true";
import { default as indexoRK7w_45U5htYgm9lurWO13v6ZZAPp8OKvl8dD7u8qGMMMeta } from "/codebuild/output/src850997479/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexbevukqC25j6RnsacEaIm2c0PCmaZP_lVZQEkJ0KwurEMeta } from "/codebuild/output/src850997479/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviHHuJ0aV2C1tZY_DOccOmQq6fvi6_45L0saNHl2ti0R6mwMeta } from "/codebuild/output/src850997479/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editCntm3mfsN0KTcq8bqtRt2YTV_SJAbQrF2mkyvSqiBBgMeta } from "/codebuild/output/src850997479/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement4AX6FcW_l4m_45_9tiGsDDsvnjGHYKuzB75477BfP_968Meta } from "/codebuild/output/src850997479/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexhbBP_453RyCG_45wAUBmT41eRhAFklV0i2fW4UuchA7K8xEMeta } from "/codebuild/output/src850997479/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dxUt7JykT3_45Qzmmqk96Gf2NSyBO_45FosGqbzBELbhuvAMMeta } from "/codebuild/output/src850997479/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmeTQZRmd44b6X1wJzBLGUcQ6qUpF27lJOmsRMwpzGnqAMeta } from "/codebuild/output/src850997479/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexO0WEwrGZCxRsLEFmT4H5ZlHj8aY6cLpNEdr89aXBQNwMeta } from "/codebuild/output/src850997479/src/src/pages/card/create/index.vue?macro=true";
import { default as indexCw08nQhleB4ScsT_th3Z6HkYmVn9zuEcutvJYZyoSsoMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmlxCx_45so_45hw_eaLKCWU4GZ_dHYWy_zB5uCbGBTrCkElIMeta } from "/codebuild/output/src850997479/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmwx5xIDaiGhLlRdB2X5v_9hyCIM_SKlv9FbcuHypPvMcMeta } from "/codebuild/output/src850997479/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completea3etKBDf_ewBK9mu3nlSUK6e5XdCiffngZ9aqFBgl8gMeta } from "/codebuild/output/src850997479/src/src/pages/membership/complete.vue?macro=true";
import { default as registerstJBkx6m_45_DrzaWtxFrGF2Aoa0WKKyQeLQm9BXFVmbwMeta } from "/codebuild/output/src850997479/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93kYrGu05jyOwsiODCpvEF3JbZnsOgZ_457rygEOMEF5bvkMeta } from "/codebuild/output/src850997479/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmEy9lcq5QpT6TmmaWWZAd7EBvXit_cMbEeVZuOaVcR_QMeta } from "/codebuild/output/src850997479/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93tIf8pqIOMAafc3iq2bhsM1c7xE6ObSE3NYA_0e_I4EoMeta } from "/codebuild/output/src850997479/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexUNokP9S7y21fEhT3vS8ZLbLLgt_45Q6_451q0auQRZBGvHIMeta } from "/codebuild/output/src850997479/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code4agQRCzgDKHVL3pjUonxbKZWqvIwhCMVeDGZqFit_452EMeta } from "/codebuild/output/src850997479/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code7BXwEZpClwK6Mog7kzd_45dDMTpCKrzRrgQj5idvIH_45YwMeta } from "/codebuild/output/src850997479/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeZOGRzIygz5vUwsdG5PCF7CvQR3caBY8l9DJ9BJjI3wIMeta } from "/codebuild/output/src850997479/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register5YVRDOfF4VFfE5kkQQArg64ToGWyS_kzUfm0Mbg4Hg0Meta } from "/codebuild/output/src850997479/src/src/pages/contact-form/register.vue?macro=true";
import { default as completer9N0k8A_O4_gwbSM_45gg7wN9Cd7N44tMohNocVgl0V60Meta } from "/codebuild/output/src850997479/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index5Ysn9macb3ORZtj_45dFhZhInbim_SgJq3gpTa2RCabmwMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmNFay3BOZ9bMwTg6wRdbBf_45XTqBTJmuch48FUfQbcIt8Meta } from "/codebuild/output/src850997479/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completevy9sR_45WDA3rt_453ePezLquB8GDI_n9ptQGYN7cmAp63oMeta } from "/codebuild/output/src850997479/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexusKoZz9N9haRP3J2hWHPQ8hb_45NqFBcuOyzKMoby_45T3YMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93Nv0_45TyVbUDT9kUq5skF94_458NFaJg7aDQIMDUemnN_45HIMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete5J5Q_gRTB8_cYFJxjR3E3epTDsGKAlx9XxMfn3xQCOgMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasmVJDjoVE1PITIWkrs9_PHFsuc9PnG3uqSJRcm6yU_S4Meta } from "/codebuild/output/src850997479/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleiSUiNQiQzQm2jB_45dkeBU4ZxVmkUacA_BL73gU60hr9UMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailgELP6Mr2jgZVSKd_453QtxON6C4x4xBdVasidPBd9HECIMeta } from "/codebuild/output/src850997479/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm0JZVSSrJJ2OwP0aXOlJttbiCHph2mggUZx4s2h1R2WAMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentLUI9SuS_45Qu_45fNibzqfMRj1WIviYJlVmAZRGPDYPgSXwMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmcOztuPXTIgiDS3V15_2EgjqT2bbR51Cr1QVxNapW7G0Meta } from "/codebuild/output/src850997479/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate5S3L_45_01qiYpdSDHNkfmMVp6h_9_4517NuJU0jyMTPCBEMeta } from "/codebuild/output/src850997479/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete9yGg557FsDCL096kbOunVp2HGf62PH4EzVUenWzDJpsMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeaBFbzFE4gcLV0_458BnygyoOmxOyYx6ZZ6qEjMdiDJZeoMeta } from "/codebuild/output/src850997479/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordXlFozlGtMjO5jnkV_45BB3gpsnXTyi8GngPTshrO1HJl0Meta } from "/codebuild/output/src850997479/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasCRj7BV78ke4hS_jkbccGr185Kdh_45wb1uQAmdxDavNXEMeta } from "/codebuild/output/src850997479/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerC5Ukk0ij4Nt4tpMlclpfHvDiJR_45zhtTk0lwILXS6Ak8Meta } from "/codebuild/output/src850997479/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codepLvsw3nmiN1T1bAgZTmOThyHkWREUmsWdpC76zmwoeIMeta } from "/codebuild/output/src850997479/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index6GRoOdLS_45JbAip5B8OM5ElS6SoHeTFkWgVjSy_45pPok8Meta } from "/codebuild/output/src850997479/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index3r_45O9gHQrOjAgGm7vXwUCxta__3a61iX2FwjSwMk4AMMeta } from "/codebuild/output/src850997479/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexv9fOhdWdj6QIlBicGhaRXmGMbO5BtTKIrfvG_450CTtPAMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexoMrX9r5haHQRkv24RupzbcQCM6JPaDY2oS3SZiTvcycMeta } from "/codebuild/output/src850997479/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update4WzD13LV6WHr9yLTGbUGK7Ct9_45BtLOTgpiS_ihCblWYMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeHYpaJ17Yd00W_454gAaJmtIfQXy_45KMWtlBLwesPcBRz1IMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmptQrSwQh60beHqNn4BOnNGPjDWIAOJ6Gq3x4swsCs6kMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexXto9ssNGkESmuGI0I0377zqevkNcVbO_J3n46CLsGBIMeta } from "/codebuild/output/src850997479/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete7RLw8gJs3sj66ZCibLU41deRpif7z_45V9yB2KjnMN2U0Meta } from "/codebuild/output/src850997479/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateEc_459voBh_a0ofHlLSIRDCbZ3UJmWGt5_9wRksYrB3vEMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index9TgMcXveSu5KEsFw3sBzsNC8UA8J6vlYa_Kawwgchd8Meta } from "/codebuild/output/src850997479/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as index_idvu7GvxLcsA5_zrgwxG2oknpMtjPVQmvqniyjh7EUMeta } from "/codebuild/output/src850997479/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completezhEaF6l7YqHHoKCOJMZp9br5xv7a8ICR8vRv__45fz3_gMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexKD0pfta2pXPZXUiITAonFumzAThdUejnOjDWEsZusvgMeta } from "/codebuild/output/src850997479/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codewW9atRCRaUqiuCu_45ssDnHi_45i715A3Dp_CB_453OKtah80Meta } from "/codebuild/output/src850997479/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexi__bkHqs_45OHyW5Qc_45sU_vapHnKH64rsW1Bdi58ex4qYMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexK_eOsCwVCBqak4ow6IKHMA2CirKhDwLm9mmEDIYgXyQMeta } from "/codebuild/output/src850997479/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexdop4ly6j3TuYgKvdMNAzrO_45VcGjil5sAvDb72A3wYlEMeta } from "/codebuild/output/src850997479/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateUhQDO7dA_bXgnQ4rA7Y3slOeNIYr5BeG57QNDQ362yUMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmw0Hfi6PqW6179vmu3eVZEaNOp_458__qvR5_45Q0BOiQxuAMeta } from "/codebuild/output/src850997479/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src850997479/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuTU3tO0CZ9IfPO_45rR_tIhIDFSGiMi5X6emgecZdOWxcEMeta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexjjC_p_45pk3ifKly9rqwYsnSfM1Uj_HsPc5nkydmmk09cMeta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src850997479/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src850997479/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src850997479/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src850997479/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src850997479/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src850997479/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src850997479/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src850997479/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexMuvRDR8YwTDG3ZMLPYSgAbdWnS4_45gXFXoo5sXupDkpIMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src850997479/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src850997479/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src850997479/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexHWsD6gdQp5sIfLOdoJkvOC65SciGXtpe6_45sntKtY5KkMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src850997479/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src850997479/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexoRK7w_45U5htYgm9lurWO13v6ZZAPp8OKvl8dD7u8qGMMMeta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexbevukqC25j6RnsacEaIm2c0PCmaZP_lVZQEkJ0KwurEMeta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src850997479/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src850997479/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src850997479/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src850997479/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src850997479/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src850997479/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexO0WEwrGZCxRsLEFmT4H5ZlHj8aY6cLpNEdr89aXBQNwMeta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmlxCx_45so_45hw_eaLKCWU4GZ_dHYWy_zB5uCbGBTrCkElIMeta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmwx5xIDaiGhLlRdB2X5v_9hyCIM_SKlv9FbcuHypPvMcMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src850997479/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completea3etKBDf_ewBK9mu3nlSUK6e5XdCiffngZ9aqFBgl8gMeta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerstJBkx6m_45_DrzaWtxFrGF2Aoa0WKKyQeLQm9BXFVmbwMeta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src850997479/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmEy9lcq5QpT6TmmaWWZAd7EBvXit_cMbEeVZuOaVcR_QMeta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src850997479/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src850997479/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code4agQRCzgDKHVL3pjUonxbKZWqvIwhCMVeDGZqFit_452EMeta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code7BXwEZpClwK6Mog7kzd_45dDMTpCKrzRrgQj5idvIH_45YwMeta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeZOGRzIygz5vUwsdG5PCF7CvQR3caBY8l9DJ9BJjI3wIMeta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register5YVRDOfF4VFfE5kkQQArg64ToGWyS_kzUfm0Mbg4Hg0Meta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src850997479/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmNFay3BOZ9bMwTg6wRdbBf_45XTqBTJmuch48FUfQbcIt8Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completevy9sR_45WDA3rt_453ePezLquB8GDI_n9ptQGYN7cmAp63oMeta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexusKoZz9N9haRP3J2hWHPQ8hb_45NqFBcuOyzKMoby_45T3YMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete5J5Q_gRTB8_cYFJxjR3E3epTDsGKAlx9XxMfn3xQCOgMeta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src850997479/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleiSUiNQiQzQm2jB_45dkeBU4ZxVmkUacA_BL73gU60hr9UMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailgELP6Mr2jgZVSKd_453QtxON6C4x4xBdVasidPBd9HECIMeta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm0JZVSSrJJ2OwP0aXOlJttbiCHph2mggUZx4s2h1R2WAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentLUI9SuS_45Qu_45fNibzqfMRj1WIviYJlVmAZRGPDYPgSXwMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmcOztuPXTIgiDS3V15_2EgjqT2bbR51Cr1QVxNapW7G0Meta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src850997479/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete9yGg557FsDCL096kbOunVp2HGf62PH4EzVUenWzDJpsMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeaBFbzFE4gcLV0_458BnygyoOmxOyYx6ZZ6qEjMdiDJZeoMeta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordXlFozlGtMjO5jnkV_45BB3gpsnXTyi8GngPTshrO1HJl0Meta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src850997479/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerC5Ukk0ij4Nt4tpMlclpfHvDiJR_45zhtTk0lwILXS6Ak8Meta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codepLvsw3nmiN1T1bAgZTmOThyHkWREUmsWdpC76zmwoeIMeta || {},
    component: () => import("/codebuild/output/src850997479/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src850997479/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src850997479/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src850997479/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src850997479/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src850997479/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src850997479/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src850997479/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src850997479/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src850997479/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]